import { Stack } from '@mui/material';
import { formatDuration } from 'date-fns';

import { PlanungsinformationFromThemaRouter, ThemaFromThemaRouter } from '../../../dtos';
import { isBlendedLearning } from '../../../utils';
import { LabelValue } from '../LabelValue';
import { content } from './TerminPlanungsinformationenCard.content';
import { getQuartalTableRows } from './TerminPlanungsinformationenCard.utils';

type FirstSectionProps = {
  readonly planungsinformation: PlanungsinformationFromThemaRouter;
  readonly strukturellesFormat: ThemaFromThemaRouter['strukturellesFormat'];
  readonly isPlanung: boolean;
};

export const FirstSection = ({ planungsinformation, strukturellesFormat, isPlanung }: FirstSectionProps) => {
  const { dauer } = planungsinformation;

  return (
    <Stack spacing={1.5}>
      {!isPlanung && !isBlendedLearning(strukturellesFormat) && (
        <LabelValue
          key={content.fields.dauer}
          label={content.fields.dauer}
          value={dauer ? formatDuration(dauer) : undefined}
        />
      )}
      {getQuartalTableRows(
        planungsinformation,
        isBlendedLearning(strukturellesFormat) ? content.fields.durchgaenge : content.fields.veranstaltungen,
      ).map(([label, value]) => (
        <LabelValue key={label} label={label} value={value} />
      ))}
    </Stack>
  );
};
